import { render, staticRenderFns } from "./Kanban.vue?vue&type=template&id=9042fde0&"
import script from "./Kanban.vue?vue&type=script&lang=js&"
export * from "./Kanban.vue?vue&type=script&lang=js&"
import style0 from "./Kanban.vue?vue&type=style&index=0&id=9042fde0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9042fde0')) {
      api.createRecord('9042fde0', component.options)
    } else {
      api.reload('9042fde0', component.options)
    }
    module.hot.accept("./Kanban.vue?vue&type=template&id=9042fde0&", function () {
      api.rerender('9042fde0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/campaign/EditCampaign/Kanban.vue"
export default component.exports